export const queryKeys = {
  msme: {
    all: ['msme'] as const,
    profile: ['msme', 'profile'] as const,
    stats: ['msme', 'stats'] as const,
    advisory: (signupGoal: string, period: string) =>
      ['msme', 'advisory', signupGoal, period] as const,
    reductionTarget: ['msme', 'reduction-target'] as const,
  },
  carbon: {
    all: ['carbon'] as const,
    savings: (period: string) => ['carbon', 'savings', period] as const,
    dashboard: ['carbon', 'dashboard'] as const,
  },
  finance: {
    overview: ['finance', 'overview'] as const,
  },
  documents: {
    all: ['documents'] as const,
    list: (params: Record<string, unknown>) => ['documents', 'list', params] as const,
    statistics: ['documents', 'statistics'] as const,
    duplicates: (params: Record<string, unknown>) => ['documents', 'duplicates', params] as const,
  },
  reporting: {
    all: ['reporting'] as const,
    footprint: (period: string) => ['reporting', 'footprint', period] as const,
    comparisons: (period: string) => ['reporting', 'comparisons', period] as const,
    readinessOverview: (period: string) => ['reporting', 'readiness-overview', period] as const,
    brsr: (period: string) => ['reporting', 'brsr', period] as const,
    iso14064: (period: string) => ['reporting', 'iso-14064', period] as const,
    iso14067: (period: string) => ['reporting', 'iso-14067', period] as const,
    cbam: (period: string) => ['reporting', 'cbam', period] as const,
    dashboard: ['reporting', 'dashboard'] as const,
    workspaceBundle: (include: string[], periodsKey: string) =>
      ['reporting', 'workspace-bundle', include.join(','), periodsKey] as const,
  },
  platform: {
    peerBenchmark: ['platform', 'peer-benchmark'] as const,
    supplierScores: ['platform', 'supplier-scores'] as const,
    scheduledReports: ['platform', 'scheduled-reports'] as const,
    draftSuggestions: ['platform', 'draft-suggestions'] as const,
  },
  compliance: {
    all: ['compliance-hub'] as const,
  },
} as const;
